import React from 'react'
import Financing from '@/pages/Financing'

const ExperimentalFinancing = () => <Financing isLoanCalculatorShown />

export default ExperimentalFinancing
